import { Icon } from '@iconify/react';
import * as CoreFns from '../utilities/CoreFns';
import * as EditorFunctions from '../utilities/EditorFunctions';

function onMouseDown(e){
  e.preventDefault();
}

function App(props) {

  var anItem = props.anItem;  
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var error = props.error;
  var itemEdited = props.itemEdited;
  var highlightAnItem = props.highlightAnItem;


  var errorString = CoreFns.errorString(error);
  var col = {};
  var className = 'normalIcon'
  if (anItem.a){
    className = 'normalIconReverse';
  }
  if (!anItem.i){
    return <div className='button-piece' onClick={anItem.f}>{anItem.t}</div>
//    
  }

  var height = '21px';
  if (anItem.i === 'bi:border-outer'){
    height = '16px';
    // col.border = '0px';
  }

  var iconStyle = {display:'table-cell', verticalAlign:'middle', textAlign:'center'};

  if (isShowingSomeDropDown && anItem.h && anItem.h === isShowingSomeDropDown.t){
    iconStyle.color = 'yellow';
    // iconStyle.color = '#222222';
  }else if (highlightAnItem && highlightAnItem.t === 'editorBar' && highlightAnItem.v === anItem.t){
    col.border = '1px solid blue';
    iconStyle.color = 'blue';
  }else{
    var el = anItem.el;
    if (el){
      for (var i = 0; i < el.length; i++){
        var thisEL = el[i];
        if (itemEdited){
          var objPath = itemEdited.path;
          var fullPath = objPath.concat(thisEL);
          var fullPathString = fullPath.join(' ');
          if (errorString){
            if (errorString.indexOf(fullPathString) === 0){
              col.border = '1px solid red';
            }
          }          
        }

      }
    }
  }

  var tip = anItem.t;
  if (anItem.h){
    tip = EditorFunctions.getHintNames(anItem.h);
  }

  var insides = <div className="input-container"  onClick={anItem.f} style={{marginBottom:'5px', display:'table'}}>
        <div className={"radio-tile noSelect " + className} onMouseDown={onMouseDown} style={col} >
          <div style={{display:'table'}}><div style={iconStyle}>
          <Icon icon={anItem.i} className='noSelect' height={height}/>
          </div></div>
        </div>
        {anItem.extra}
      </div>
//
  if (tip){
    return <i className="qtip tip-bottom" data-tip={tip} >
        {insides}
      </i>
  }else{
    return insides;
  }
//
//
}

export default App;